module.exports = __webpack_public_path__ + "static/media/BEAR.f255d63b.png";